import styled from 'styled-components'
import { FormContent } from '../../pages/Traceability/formStyle'

export const Content = styled(FormContent)`
  width: calc(100% - 56px); max-width: 760px; margin: 28px auto;
  @media (max-width: 760px) { width: calc(100% - 28px); margin: 20px auto; }
`
